import React, { createRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Component from "../../../Component";
import { gsap, TweenMax } from "gsap";
import { Draggable } from "gsap/Draggable";
import CompassImage from "../../../../common/img/compass.svg";
gsap.registerPlugin(Draggable);
export class CompassViewSP extends Component {
    constructor(props) {
        super(props);
        this.compassRef = React.createRef();
    }
    state = {
        isSavingCompassSetting: this.props.isSavingCompassSetting,
        currentDrawing: this.props.currentDrawing,
        isSelected: this.props.isSelected,
        direction: this.props.direction
    }
    componentDidMount() {
        Draggable.create(this.compassRef.current, {
            type: "x,y",
            bounds: document.getElementById(`${this.props.bounds}`),
            onDragEnd: () => {
            }
        });
        gsap.set(this.compassRef.current, { rotation: this.props.isSavingCompassSetting ? this.props.savingDirection : this.props.direction });
    }

    componentWillReceiveProps(nextProps) {
    }
    componentDidUpdate() {
        // let value = this.props.direction ? 0 : this.props.direction;
            Draggable.create(this.compassRef.current, {
                type: "x,y",
                y: 0,
                x: 0,
                bounds: document.getElementById(`${this.props.bounds}`),
                onDragEnd: () => {
                }
            });
            gsap.set(this.compassRef.current, { rotation: this.props.isSavingCompassSetting ? this.props.savingDirection : this.props.direction });

    }
    render() {
        // const { direction } = this.state
        const {
            drawingsUC,
            isSavingCompassSetting,
            currentDrawing,
            isSelected,
            direction,
            isCompassSetting
        } = this.props;

        return (
            <>
                {((!isSavingCompassSetting && direction) || (isSavingCompassSetting && (isSelected || currentDrawing))) &&
                    <div id={`container-${drawingsUC}`}
                        className={`compassview-container${isSavingCompassSetting ? "-saving" : ""} ${!isCompassSetting ? " text-left" : !isSavingCompassSetting ? " text-right" : ""}`}>
                        <img
                            ref={this.compassRef}
                            className={`${!isSavingCompassSetting ? "compass-sp-view-icon"
                                : (currentDrawing ? "compass-sp-view-icon-setting-currentDrawing" :
                                    (isSelected ? "compass-sp-view-icon-setting-selected" :
                                        (!isSelected ? "compass-sp-view-icon-setting" : "")))}`}
                            src={CompassImage}
                        />
                    </div>
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    type: state.rootSitesReducer.siteInfoReducer.type
});

export default connect(mapStateToProps)(withRouter(CompassViewSP));
